import { Loading } from "element-ui";
import { Message } from "element-ui";

let loadingInstance = undefined;

export default {
  tipsLogin: function() {
    this.tips("error", "请您先登录！");
  },

  tips: function(type, message) {
    Message({
      type: type,
      message: message || "服务器错误",
      center: false,
      offset: 100, //距离顶部的距离
      duration: 3000,
    });
  },

  loading(close = true, text = "加载中~") {
    if (!close) {
      if (loadingInstance) {
        loadingInstance.close();
        loadingInstance = undefined;
      }
      return;
    }
    if (loadingInstance) {
      loadingInstance.text = text;
    } else {
      loadingInstance = Loading.service({
        text,
        background: "rgba(255,255,255,0.5)",
      });
    }
  },

  //设置sessionStorage存储数据
  setSess: (name, content) => {
    if (!name) return;
    if (typeof content !== "string") {
      content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
  },

  //获取sessionStorage存储数据
  getSess: (name) => {
    if (!name) return "";
    return window.sessionStorage.getItem(name);
  },

  //删除sessionStorage存储数据
  removeSess: (name) => {
    if (!name) return;
    window.sessionStorage.removeItem(name);
  },

  storage: (function() {
    return {
      get: function(name) {
        return JSON.parse(sessionStorage.getItem(name));
      },
      set: function(name, val) {
        sessionStorage.setItem(name, JSON.stringify(val));
      },
      remove: function(name) {
        sessionStorage.removeItem(name);
      },
    };
  })(),

  localStorage: (function() {
    return {
      get: function(name) {
        return JSON.parse(localStorage.getItem(name)) || {};
      },
      set: function(name, val) {
        localStorage.setItem(name, JSON.stringify(val));
      },
      remove: function(name) {
        localStorage.removeItem(name);
      },
    };
  })(),

  setCookie(c_name, value, expiredays) {
    let exp = new Date();
    exp.setTime(exp.getTime() + expiredays);
    document.cookie =
      c_name +
      "=" +
      encodeURIComponent(value) +
      ";expires=" +
      exp.toGMTString() +
      ";path=/";
    return true;
  },

  getCookie(c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },

  clearCookie: function(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  },

  clearAmdoxCookie: function(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = this.getCookie(name);
    if (cval != null)
      document.cookie =
        name +
        "=" +
        cval +
        ";path=/;domain=amdox.com.cn;expires=" +
        exp.toGMTString();
  },

  delCookie(name) {
    this.setCookie(name, "", -1);
  },

  //获取search
  getUrlSearch: function(search) {
    // search == > window.location.search
    var searchString = decodeURIComponent(search).substring(1);
    //	用 decodeURIComponent 对 URI 进行解码。
    //	使用 substring 是因为 substr 在 w3cSchool 中说 ECMAscript 没有标准化该方法
    var searchArr = searchString.split("&");
    var returnObj = {},
      switchStr = "",
      loopArr = [];

    for (var i = 0; i < searchArr.length; i++) {
      switchStr = searchArr[i];
      switch (switchStr.indexOf("=")) {
        case -1:
          //	如果没有 '=' 则参数对应值为''
          returnObj[switchStr] = "";
          break;
        case 0:
          //	如果 '=' 之前无参数名则跳过循环
          break;
        default:
          var loopArr = switchStr.split("=");
          //	'=' 之后如果没有值会在split的时候为''
          returnObj[loopArr[0]] = loopArr[1];
          loopArr = [];
          break;
      }
      switchStr = "";
    }
    return returnObj;
  },

  formatTime(num) {
    var date = new Date(num); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() + " ";
    var h = date.getHours() + ":";
    var m = date.getMinutes() + ":";
    var s = date.getSeconds();
    // return Y+M+D;
    return Y + M + D + h + m + s;
  },

  timeFormat(num) {
    var date = new Date(num); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() + " ";
    var h = date.getHours() + ":";
    var m = date.getMinutes() + ":";
    var s = date.getSeconds();
    return Y + M + D;
  },

  //秒转换成时间格式
  formatSeconds(value) {
    var theTime = parseInt(value);
    var theTime1 = 0;
    var theTime2 = 0;

    if (theTime >= 60) {
      theTime1 = parseInt(theTime / 60);
      theTime = parseInt(theTime % 60);
      if (theTime1 >= 60) {
        theTime2 = parseInt(theTime1 / 60);
        theTime1 = parseInt(theTime1 % 60);
      }
    }
    if (theTime < 10) {
      theTime = "0" + parseInt(theTime);
    }
    var result = "" + theTime + "";
    if (theTime1 >= 0) {
      if (theTime1 < 10) {
        theTime1 = "0" + parseInt(theTime1);
      }
      result = "" + theTime1 + ":" + result;
    }
    if (theTime2 >= 0) {
      if (theTime2 < 10) {
        theTime2 = "0" + parseInt(theTime2);
      }
      result = "" + theTime2 + ":" + result;
    }
    return result;
  },

  judgeModifyForm(olddata, newdata) {
    // 判断表单数据是否修改
    let isChangeData = 0; // 0--未修改，1--已修改
    // console.log(olddata)
    // console.log(newdata)
    for (let i in newdata) {
      if (newdata[i] != olddata[i]) {
        isChangeData = 1;
        // console.log("new value:",i,newdata[i])
        // console.log("old value", olddata[i])
      }
    }
    return isChangeData;
  },

  f_check_IP(ip) {
    var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; //正则表达式
    if (re.test(ip)) {
      if (
        RegExp.$1 < 256 &&
        RegExp.$2 < 256 &&
        RegExp.$3 < 256 &&
        RegExp.$4 < 256
      )
        return true;
    }
    return false;
  },

  //字符传转字节
  stringToByte(str) {
    var bytes = new Array();
    var len, c;
    len = str.length;
    for (var i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(((c >> 18) & 0x07) | 0xf0);
        bytes.push(((c >> 12) & 0x3f) | 0x80);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(((c >> 12) & 0x0f) | 0xe0);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(((c >> 6) & 0x1f) | 0xc0);
        bytes.push((c & 0x3f) | 0x80);
      } else {
        bytes.push(c & 0xff);
      }
    }
    return bytes;
  },

  //字节转字符串
  byteToString(arr) {
    if (typeof arr === "string") {
      return arr;
    }
    var str = "",
      _arr = arr;
    for (var i = 0; i < _arr.length; i++) {
      var one = _arr[i].toString(2),
        v = one.match(/^1+?(?=0)/);
      if (v && one.length == 8) {
        var bytesLength = v[0].length;
        var store = _arr[i].toString(2).slice(7 - bytesLength);
        for (var st = 1; st < bytesLength; st++) {
          store += _arr[st + i].toString(2).slice(2);
        }
        str += String.fromCharCode(parseInt(store, 2));
        i += bytesLength - 1;
      } else {
        str += String.fromCharCode(_arr[i]);
      }
    }
    return str;
  },

  /**
   * @desc 函数节流
   * @param func 函数
   * @param wait 延迟执行毫秒数
   * @param type 1 表时间戳版，2 表定时器版
   */
  throttle(func, wait, type) {
    if (type === 1) {
      let previous = 0;
    } else if (type === 2) {
      let timeout;
    }
    return function() {
      let context = this;
      let args = arguments;
      if (type === 1) {
        let now = Date.now();
        if (now - previous > wait) {
          func.apply(context, args);
          previous = now;
        }
      } else if (type === 2) {
        if (!timeout) {
          timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
          }, wait);
        }
      }
    };
  },
};
